import * as yup from "yup";
import { emailMustBeValidEmail } from "../../../../common/infrastructure/helpers/yupHelper";

export const loginFormSchema = yup.object({
  email: yup
    .string()
    .email(emailMustBeValidEmail())
    .required("Полето 'Имейл' е задължително")
    .trim()
    .max(200),

  password: yup
    .string()
    .required("Полето 'Парола' е задължително")
    .trim()
    .max(200),
});

export type ILoginFormModel = yup.InferType<typeof loginFormSchema>;

export const loginFormDefaultValues: ILoginFormModel = {
  email: "",
  password: "",
};
